import { css } from 'linaria';

export const productQualityDocumentsWrapper = css`
  display: flex;
  flex-direction: column;
  gap: var(--space-500);
  margin-bottom: var(--space-200);

  @media (--from-tablet) {
    margin-bottom: var(--space-500);
  }
`;

export const fileTextIconWrapper = css`
  padding: var(--space-100);
  border-radius: var(--rounding-m);
  border: 1px solid var(--control-minor);
`;

export const listItem = css`
  padding-left: var(--space-300);

  @media (--from-tablet) {
    padding-left: var(--space-100);
  }

  li {
    column-gap: var(--space-150);
  }
`;

export const divider = css`
  margin: 0;

  @media (--only-mobile) {
    display: none;
  }
`;
